import _Box from "@mui/material/Box";
import _Typography from "@mui/material/Typography";
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
function BfgWhyCard() {
  const {
    t
  } = useTranslation();
  const items = [{
    emoji: '🤝',
    title: t('commons.challenges.bfg_faq.why.velotaf_conversion_title'),
    description: t('commons.challenges.bfg_faq.why.velotaf_conversion_description')
  }, {
    emoji: '🌳',
    title: t('commons.challenges.bfg_faq.why.goodplanet_support_title'),
    description: t('commons.challenges.bfg_faq.why.goodplanet_support_description')
  }, {
    emoji: '🎁',
    title: t('commons.challenges.bfg_faq.why.employee_gifts_title'),
    description: t('commons.challenges.bfg_faq.why.employee_gifts_description')
  }, {
    emoji: '⚡',
    title: t('commons.challenges.bfg_faq.why.mobility_data_title'),
    description: t('commons.challenges.bfg_faq.why.mobility_data_description')
  }];
  return /*#__PURE__*/React.createElement(_Box, {
    bgcolor: "#fff",
    border: "1px solid #D9E7FF",
    borderRadius: 4,
    display: "flex",
    flexDirection: "column",
    gap: 3,
    padding: 3
  }, /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    gap: 1
  }, /*#__PURE__*/React.createElement(_Typography, {
    sx: {
      fontSize: 18,
      fontWeight: 800
    }
  }, t('commons.challenges.bfg_faq.why.title')), /*#__PURE__*/React.createElement(_Typography, {
    color: "textSecondary",
    variant: "body2"
  }, t('commons.challenges.bfg_faq.why.description'))), /*#__PURE__*/React.createElement(_Box, {
    display: "grid",
    gap: 2,
    gridTemplateColumns: {
      sm: '1fr 1fr',
      xs: '1fr'
    }
  }, items.map(({
    emoji,
    title,
    description
  }) => /*#__PURE__*/React.createElement(_Box, {
    border: "1px solid #D9E7FF",
    borderRadius: 3,
    display: "flex",
    flexDirection: "column",
    gap: 1,
    key: title,
    minWidth: 0,
    padding: 2
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 24
    }
  }, emoji), /*#__PURE__*/React.createElement(_Typography, {
    sx: {
      fontSize: 16,
      fontWeight: 800
    }
  }, title), /*#__PURE__*/React.createElement(_Typography, {
    color: "textSecondary",
    variant: "body2"
  }, description)))), /*#__PURE__*/React.createElement(_Box, {
    alignItems: "flex-start",
    bgcolor: "#f0faf5",
    borderRadius: 2,
    display: "flex",
    gap: 1,
    padding: 2
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      flexShrink: 0
    }
  }, "\uD83D\uDD11"), /*#__PURE__*/React.createElement(_Typography, {
    variant: "body2"
  }, /*#__PURE__*/React.createElement(Trans, {
    components: [/*#__PURE__*/React.createElement("strong", {
      key: 0
    })],
    i18nKey: "commons.challenges.bfg_faq.why.key_in_hand"
  }))));
}
export default BfgWhyCard;